import { render } from "./FansStore.vue?vue&type=template&id=1b7c8570&scoped=true"
import script from "./FansStore.vue?vue&type=script&lang=js"
export * from "./FansStore.vue?vue&type=script&lang=js"

import "./FansStore.vue?vue&type=style&index=0&id=1b7c8570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7c8570"]])

export default __exports__